import React from "react";
import { Row, Col } from "antd";
import { VisualTotalInfomation } from "../individual_user/TotalInformation";
import FrequencyGraph from "../FrequencyGraph";
import { CompareCol } from "../../../containers/ReportPanels/CompareValuePanel";
import i18n from "../../../i18n/";
import { ArrayUtil } from "../../../util";

export default ({colorType, data, isVertical, dateRange})=>{
	const mutateDateRange = ArrayUtil.isAliveArray(dateRange) && (dateRange.length === 2) ? [
		dateRange[0] ? dateRange[0].format("X") : null,
		dateRange[1] ? dateRange[1].format("X") : null
	] : undefined;
	return (<div style={{minHeight:377}}>
		<Row gutter={16}>
			<Col span={12}>
				<VisualTotalInfomation
					style={{marginBottom:10}}
					total={data ? data.total_session : 0}
					description={i18n.t("total_test_session")}
					visualColorKey={colorType}
				/>
			</Col>
			<Col span={12}>
				<VisualTotalInfomation
					style={{marginBottom:10}}
					total={data ? data.total_user : 0}
					description={i18n.t("total_user")}
					visualColorKey={colorType}
				/>
			</Col>
		</Row>
		<Row>
			<Col span={24}>
				<FrequencyGraph
					data={data ? data.data : {}}
					date_range={mutateDateRange ? mutateDateRange : null}
					chart_id={`${colorType}_frequency_graph`} 
					visualColorKey = {colorType}
				/>
			</Col>
		</Row>
	</div>
	);
};


// WEBPACK FOOTER //
// ./src/components/report/stress/FrequencyGraphBox.js